import { mapActions } from 'vuex';
import store from '@/store/index';
import { parseQuery } from '@/utils/helpers';
import scrollTo from '@/utils/scrollTo';
import { MODALS } from '@/components/app/app-modals/app-modals';
import { STATIC_PAGES } from '@/constants';
import cmsContentMixin from '@/mixins/cmsContent';

let toRoute = '';
let restore = true;

export default {
  mixins: [
    cmsContentMixin,
  ],
  metaInfo() {
    return {
      title: 'Terms and Conditions',
    };
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.getStaticPageFull(STATIC_PAGES.TERMS)
      .then((data) => {
        this.installDynamicControls({ data });
      });
  },
  mounted() {
    const query = parseQuery(window.location.search);
    if (query && query.section) {
      setTimeout(() => scrollTo(document.getElementById(query.section), 0), 50);
    }
  },
  beforeDestroy() {
    // firest after router loop
    if (restore) {
      store.dispatch('popup/restorePopup', toRoute);
    }
  },
  beforeRouteEnter(to, from, next) {
    const popup = to.params.noPopup ? null : MODALS.REGISTER;
    store.dispatch('popup/rememberPopup', {
      route: from.name,
      popup,
    });
    next();
  },
  beforeRouteLeave(to, from, next) {
    // fires before router loop closes popup
    restore = to.name !== 'privacy-policy';
    toRoute = to.name;
    next();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-terms-and-conditions/page-terms-and-conditions.js